import styles from './ExploreButton.module.scss';
import { showRightArrowIcon } from '../../core/core';

const ExploreButton = ({ small, disabled, ...otherProps }) => (
  <div className={styles.exploreButton}>
    <button type='button' disabled={disabled} {...otherProps}>
      Explore &nbsp;{showRightArrowIcon()}
    </button>
  </div>
);

export default ExploreButton;
